import { gl } from '../../../Engine';
import { Uniform } from './Uniform';

export class UniformInt extends Uniform {
    constructor(name: string) {
        super(name);
    }

    loadInt(value: number) {
        if (this.location) {
            gl.uniform1i(this.location, value);
        }
    }
}
